export const QuotationModes = [ 'road', 'air', 'ocean' ] as const;
export type QuotationMode = typeof QuotationModes[number];
